export default function getQueryNames(query: any): string[] {
  return query?.definitions[0]?.selectionSet?.selections?.map((q: any) => q?.name?.value || null).filter((t: any) => !!t) || []
}
